import React, { useEffect } from "react";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import useAgencyPitches from "../../hooks/agency/useAgencyPitches";
import AgencyPitchesMobileHeader from "../../components/agency/responsive/AgencyPitchesMobileHeader";
import AgencyPitchesMobileSearchSort from "../../components/agency/responsive/AgencyPitchesMobileSearchSort";
import AgencyPitchesMobileFilters from "../../components/agency/responsive/AgencyPitchesMobileFilters";
import DesktopFiltersBar from "../../components/agency/DesktopFiltersBar";
import AgentFilterDropdown from "../../components/agency/AgentFilterDropdown";
import PositionFilterDropdown from "../../components/agency/PositionFilterDropdown";
import PitchesTable from "../../components/agency/PitchesTable";
import { exportPitchesToExcel } from "../../utils/exportPitches";
import { getPositionDisplay } from "../../utils/positionFormatter";

const AgencyPitches = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const {
    filters,
    showAgentFilter,
    setShowAgentFilter,
    showPositionFilter,
    setShowPositionFilter,
    pitches,
    agents,
    positions,
    pitchesLoading,
    exportingData,
    setExportingData,
    handleSearchChange,
    handleAgentToggle,
    handlePositionToggle,
    handleAllAgentsToggle,
    handleAllPositionsToggle,
    handleSortChange,
    handleAgentClick,
    handlePlayerClick,
    handleClubClick,
    agentFilterText,
    positionFilterText,
  } = useAgencyPitches();

  const handleExportToExcel = () => {
    exportPitchesToExcel(pitches, filters, setExportingData);
  };


  useEffect(()=>{
    console.log("Positions updated:", positions);
  },[positions])


  return (
    <div className="pb-8">
      {isMobile ? (
        <>
          <AgencyPitchesMobileHeader
            onExport={handleExportToExcel}
            exportingData={exportingData}
            disabled={pitches.length === 0}
          />
          <AgencyPitchesMobileSearchSort
            searchTerm={filters.search}
            onSearchChange={handleSearchChange}
            sortBy={filters.sort}
            onSortChange={handleSortChange}
          />
          <AgencyPitchesMobileFilters
            onAgentFilterClick={() => setShowAgentFilter(!showAgentFilter)}
            onPositionFilterClick={() =>
              setShowPositionFilter(!showPositionFilter)
            }
            agentFilterText={`Applied by: ${agentFilterText}`}
            positionFilterText={`Filter by: ${positionFilterText}`}
          />
        </>
      ) : (
        <>
          <div className="px-12 py-4 border-b border-[#E5E6E8]">
            <h1 className="text-[#202630] text-xl font-bold">Agency Pitches</h1>
          </div>
          <DesktopFiltersBar
            searchTerm={filters.search}
            onSearchChange={handleSearchChange}
            sortBy={filters.sort}
            onSortChange={handleSortChange}
            onExport={handleExportToExcel}
            exportingData={exportingData}
            disabled={pitches.length === 0}
            onAgentFilterClick={() => setShowAgentFilter(!showAgentFilter)}
            onPositionFilterClick={() => setShowPositionFilter(!showPositionFilter)}
            agentFilterText={agentFilterText}
            positionFilterText={positionFilterText}
          />

          {showAgentFilter && (
            <div className="absolute top-[200px] left-0 mt-2 w-80 bg-white border border-[#D6DBEA] rounded-lg shadow-lg z-20 p-4 ml-12">
              <AgentFilterDropdown
                agents={agents}
                filters={filters}
                agentFilterText={agentFilterText}
                onAgentToggle={handleAgentToggle}
                onAllAgentsToggle={handleAllAgentsToggle}
              />
            </div>
          )}

          {showPositionFilter && (
            <div className="absolute top-[200px] left-[212px] mt-2 w-64 bg-white border border-[#D6DBEA] rounded-lg shadow-lg z-20 p-4 ml-12">
              <PositionFilterDropdown
                positions={positions}
                filters={filters}
                positionFilterText={positionFilterText}
                onPositionToggle={handlePositionToggle}
                onAllPositionsToggle={handleAllPositionsToggle}
              />
            </div>
          )}
        </>
      )}

      {isMobile && showAgentFilter && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={() => setShowAgentFilter(false)}
        >
          <div
            className="bg-white rounded-lg w-11/12 max-w-md p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <AgentFilterDropdown
              agents={agents}
              filters={filters}
              agentFilterText={agentFilterText}
              onAgentToggle={handleAgentToggle}
              onAllAgentsToggle={handleAllAgentsToggle}
            />
          </div>
        </div>
      )}
      {isMobile && showPositionFilter && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={() => setShowPositionFilter(false)}
        >
          <div
            className="bg-white rounded-lg w-11/12 max-w-md p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <PositionFilterDropdown
              positions={positions}
              filters={filters}
              positionFilterText={positionFilterText}
              onPositionToggle={handlePositionToggle}
              onAllPositionsToggle={handleAllPositionsToggle}
            />
          </div>
        </div>
      )}

      {!isMobile && (showAgentFilter || showPositionFilter) ? (
        <div
          className="fixed inset-0 z-10"
          onClick={() => {
            setShowAgentFilter(false);
            setShowPositionFilter(false);
          }}
        />
      ) : null}

      <div className={`w-full ${isMobile ? "px-4" : "px-12"}`}>
        <PitchesTable
          pitches={pitches}
          pitchesLoading={pitchesLoading}
          onAgentClick={handleAgentClick}
          onPlayerClick={handlePlayerClick}
          onClubClick={handleClubClick}
        />
      </div>
    </div>
  );
};

export default AgencyPitches;
